export interface DomainEntry {
  url: string;
  label: string;
  status: 'stable' | 'new' | 'backup';
  speed: 'fast' | 'normal';
  lastChecked: string;
}

export const domains: DomainEntry[] = [
  { url: 'https://hlw2025.com', label: '主域名', status: 'stable', speed: 'fast', lastChecked: '2025-08-07' },
  { url: 'https://hlw888.vip', label: '最新域名', status: 'new', speed: 'fast', lastChecked: '2025-08-07' },
  { url: 'https://hlw666.top', label: '备用域名', status: 'backup', speed: 'normal', lastChecked: '2025-08-07' },
  { url: 'https://hlw2025.net', label: '镜像站点', status: 'stable', speed: 'fast', lastChecked: '2025-08-07' },
  { url: 'https://hlw365.org', label: '永久地址', status: 'stable', speed: 'normal', lastChecked: '2025-08-07' },
  { url: 'https://hlw999.cc', label: '防封入口', status: 'new', speed: 'fast', lastChecked: '2025-08-07' },
];

export const siteInfo = {
  name: '黑料网',
  description: '黑料网永久域名入口导航站，实时更新最新可用域名与防封地址，确保用户随时稳定访问黑料网。收藏本页，告别频繁换域烦恼，安全快速直达黑料网。',
  keywords: '黑料网永久域名,黑料网最新域名,黑料网不封地址,黑料网入口地址,黑料网永久链接,黑料网备用域名,黑料网最新网址2025',
  year: 2025,
};